import { render, staticRenderFns } from "./ProjectPlannedResourcesResponsibleAndSubscribersWrapItem.vue?vue&type=template&id=50c14fc8&scoped=true&"
import script from "./ProjectPlannedResourcesResponsibleAndSubscribersWrapItem.vue?vue&type=script&lang=js&"
export * from "./ProjectPlannedResourcesResponsibleAndSubscribersWrapItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlannedResourcesResponsibleAndSubscribersWrapItem.vue?vue&type=style&index=0&id=50c14fc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c14fc8",
  null
  
)

export default component.exports